// @flow
import React from 'react'
import I18n from 'I18n'
import styles from './Login.module.scss'

import UserIcon from './svgIcons/user.svg'
import LockIcon from './svgIcons/lock.svg'
import HomeIcon from './svgIcons/home.svg'

import Loading from 'modules/Common/components/Loading'

const I18nLocal = I18n.landing

export type Props = {
  name: string,
  password: string,
  company?: string,
  handleChangeName: (value: string) => void,
  handleChangePassword: (value: string) => void,
  handleChangeCompany?: (value: string) => void,
  login: () => void,
  isLogging: boolean,
  isAdminLogin?: boolean
};
const renderInput = (type: string, placeholder: string, value?: string, onChange?: (value: string) => void, Icon: any) => {
  return (
    <span className={styles.input}>
      <Icon width={30} height={30} />
      <input
        type={type}
        placeholder={placeholder}
        value={value || ''}
        onChange={e => {
          onChange && onChange(e.target.value)
        }}
      />
    </span>
  )
}
const InputForm = (props: Props) => {
  return (
    <div className={styles.form}>
      <span className={styles.title}>{props.isAdminLogin ? I18nLocal.adminSignIn : I18nLocal.signIn}</span>
      {renderInput('text', I18nLocal.username, props.name, props.handleChangeName, UserIcon)}
      <hr className={styles.line} />
      {renderInput('password', I18nLocal.password, props.password, props.handleChangePassword, LockIcon)}
      <hr className={styles.line} />
      {!props.isAdminLogin ? renderInput('text', I18nLocal.company, props.company, props.handleChangeCompany, HomeIcon) : null}
      {!props.isAdminLogin ? <hr className={styles.line} /> : null}
      <span className={styles.button} onClick={props.login}>
        {!props.isLogging ? (
          I18nLocal.signIn
        ) : (
          <div>
            <Loading spin='circle' hideTitle={true} />
          </div>
        )}
      </span>
    </div>
  )
}

export default InputForm
